var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s((_vm.day + "天" + _vm.hr + ":" + _vm.min + ":" + _vm.sec)))])}
var staticRenderFns = []

export { render, staticRenderFns }